<template>
  <transition mode="out-in"
              enter-active-class="animate__animated animate__fadeIn"
              leave-active-class="animate__animated animate__fadeOut">
    <div v-if="hasNoSlots" role="alert" ref="resAlert" class="app-alert-error" id="noReservations">
      <img src="@ridmv/web-themes/images/icons/exclamation-triangle-solid.svg" alt="">
      <div>
        <p>No reservations are currently available, please check back at a later time.</p>
        <RiDmvHome />
      </div>
    </div>
    <div v-else-if="resFeeApplicable || resIsLastPage"
         role="alert"
         ref="resAlert"
         class="app-alert-warning"
         id="resAlert">
      <img src="@ridmv/web-themes/images/icons/exclamation-triangle-solid.svg" alt="">
      <div>
        <p v-if="resFeeApplicable">
          There is a fee associated for the reservation you are making.
          Payment will be collected before your reservation is confirmed.
        </p>
        <p v-if="resIsLastPage">
          These are the last available reservations.
        </p>
      </div>
    </div>
  </transition>
</template>


<script setup>
import { computed, ref, watch } from 'vue';
import { useStore } from 'vuex';
import RiDmvHome from '../../RiDmvHome.vue'; 

// Vuex store
const store = useStore();

// Reactive State
const hasNoSlots = ref(false);

// Computed properties
const availableSlotsByVisitType = computed(() => store.state.user.availableSlotsByVisitType);
const resIsLastPage = computed(() => store.state.user.resIsLastPage);
const resFeeApplicable = computed(() => store.state.user.resFeeApplicable);

// Watcher 
/**
 * Set hasNoSlots in watcher instead of computed to avoid premature rendering of "no slots" alert.
 */
watch(availableSlotsByVisitType, (newSlots) => {
  hasNoSlots.value = newSlots.length === 0;
});
</script>


<style scoped lang="scss">
.app-alert-error, .app-alert-warning {
  // designer insisted on the one-off spacing
  padding: calc(var(--padding-vertical) * 1.25) 1.25rem calc(var(--padding-vertical) * 0.75) 1.25rem !important;
  img {
    margin-top: 5px;
  }
  p:first-child {
    @extend %alert-emphasis;
    padding-top: 0;
    padding-bottom: 0.5em;
  }
}
</style>
